import pipe from 'transmute/pipe';
// @ts-expect-error not typed
import { getMessage } from './widgetDataGetters';
// @ts-expect-error not typed
import { getGdprCookieConsentPromptMessage } from '../../message/operators/messageGetters';
export const gdprCookieConsentPromptMessage = pipe(getMessage, getGdprCookieConsentPromptMessage);